module.exports = __webpack_public_path__ + "static/media/standigforbattring.1fdd5a35.jpg";